import ConfigAnalytics from '../configs/ConfigAnalytics';
import Cookies from "js-cookie";

const parseReviews = (data) => ConfigAnalytics.request({
  data,
  url: '/external_reviews/parse',
  method: 'POST',
  headers: {
    Authorization: Cookies.get('adminToken'),
  }
});

const parseClinicFromSite = (data) => ConfigAnalytics.request({
  data,
  url: '/external_clinics_parser/clinic-from-site',
  method: 'POST',
  headers: {
    Authorization: Cookies.get('adminToken'),
  }
});


export default {
  parseReviews,
  parseClinicFromSite,
};
